import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { ObjectPropertiesWrapper } from "~/components/ModalObjects";

export const TemplateObject = ({ children, isForm, className }) => {
  return (
    <div
      className={classNames(
        "task_edit_mode tw-flex tw-flex-col lg:tw-flex-row tw-max-w-full tw-w-full tw-p-2",
        className,
        {
          "tw-min-h-full": !isForm,
          "tw-gap-0 lg:tw-gap-2": isForm,
        }
      )}
    >
      <div
        className={classNames("tw-pl-6 tw-pt-6 lg:tw-grow", {
          "tw-pr-6": !isForm,
        })}
      >
        {children[0]}
      </div>
      <ObjectPropertiesWrapper
        className={classNames("tw-max-w-[328px] tw-w-full lg:tw-w-[328px] tw-shrink-0", {
          "tw-mt-4 lg:tw-mt-0": isForm,
        })}
        isForm={isForm}
      >
        {children[1]}
      </ObjectPropertiesWrapper>
    </div>
  );
};

TemplateObject.propTypes = {
  children: PropTypes.array,
  isForm: PropTypes.bool,
  className: PropTypes.string,
};
